export const OPACITY = 'opacity'
export const LEFT = 'left'
export const RIGHT = 'right'
export const TOP = 'top'
export const REALISTIC = 'realistic'

export const EXIT = 'Exit'
export const ENTER = 'Enter'
